import React, { FormEvent, memo, ReactElement, useEffect, useState } from 'react';
import gtmIds from 'adapter/in/dashboards/config/gtm';
import { usePermissions } from 'adapter/in/dashboards/context/Permissions';
import { isSome } from 'fp-ts/lib/Option';
import Home from 'adapter/in/common/components/Home/Home';
import useCreateDashboardModal from 'adapter/in/dashboards/containers/Modals/CreateDashboardModal/useCreateDashboardModal';
import MarketAppTableContainer from 'adapter/in/dashboards/containers/Dashboards/MarketAppTable';
import i18n from 'asset/translation';
import DashboardsTableContainer from 'adapter/in/dashboards/containers/Dashboards/DashboardsTable/DashboardTableContainer';
// import { useDebounce } from 'adapter/in/dashboards/utils/useDebounce';
import { useDashboards } from 'adapter/in/dashboards/context/Dashboards';
import { dispatchMarketApps } from 'adapter/in/dashboards/context/MarketApps';
import { Button } from '@dexma/ui-components';

type DashboardsContainerProps = {
    pathUrl: string;
};
const DashboardsContainer = (props: DashboardsContainerProps): ReactElement => {
    const { pathUrl } = props;
    const { permissions } = usePermissions();
    const [filterParam, setFilterParam] = useState('');
    // Deactivate debounce until request against backend for filtering Dashboards
    // const debouncedSearchTerm = useDebounce(filterParam, 600);
    const handleSearchChange = (event: FormEvent<HTMLInputElement>) => {
        setFilterParam(event.currentTarget.value);
    };

    // TODO: We perform a reset of the dashboards and market apps when the component is unmounted,
    // due to problems of the architecture to inject context providers & use cases.
    const { getReset: resetDashboards } = useDashboards();
    const { reset: resetMarketApps } = dispatchMarketApps();
    const { modal, showModal } = useCreateDashboardModal();

    useEffect(
        () => () => {
            resetDashboards();
            resetMarketApps();
        },
        []
    );

    return (
        <Home
            addButtonProps={{
                displayAddButton: isSome(permissions) && permissions.value.create,
                addButton: (
                    <Button
                        kind='iconTextButton'
                        data-testid='create-button'
                        dataId={gtmIds.dashboards.actions.create}
                        variant='primary'
                        iconBefore='add'
                        onClick={() => {
                            showModal();
                        }}
                        text={i18n.t('dashboards.ariaLabel.addDashboard')}
                    />
                ),
            }}
            searchDataId={gtmIds.dashboards.actions.search}
            headingTitle={i18n.t('dashboards.dashboards')}
            handleSearchChange={handleSearchChange}
        >
            <DashboardsTableContainer debouncedSearchTerm={filterParam} />
            <MarketAppTableContainer pathUrl={pathUrl} />
            {modal}
        </Home>
    );
};

export default memo(DashboardsContainer);
